<template>
  <v-container fluid class="px-0">
    <v-row class="mb-3">
      <v-col cols="12" md="6">
        <el-text-field
          need
          label="Identifikavimo kodas"
          tooltip="Hipoteka. Turtas. Orlaivis. Identifikavimo kodas"
          :counter="10"
          :readonly="turtasReadonly || !sudarymas"
          v-model="formData.tur_identifikatorius"
          :autofocus="!turtasReadonly && sudarymas"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-text-field
          need
          label="Nacionalinis ir registracijos ženklai"
          tooltip="Hipoteka. Turtas. Orlaivis. Nacionalinis ir registracijos ženklai"
          :counter="10"
          :readonly="turtasReadonly"
          v-model="formData.tur_orlaivis_registracijos_zenklas"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-text-field
          need
          label="Registravimo liudijimo numeris"
          tooltip="Hipoteka. Turtas. Orlaivis. Registravimo liudijimo numeris"
          :counter="20"
          :readonly="turtasReadonly"
          v-model="formData.tur_orlaivis_registracijos_numeris"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-text-field
          need
          label="Serijos numeris"
          tooltip="Hipoteka. Turtas. Orlaivis. Serijos numeris"
          :counter="20"
          :readonly="turtasReadonly"
          v-model="formData.tur_orlaivis_serijos_numeris"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-date-picker
          need
          label="Registracijos data"
          tooltip="Hipoteka. Turtas. Orlaivis. Registracijos data"
          :readonly="turtasReadonly"
          v-model="formData.tur_orlaivis_registracijos_data"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-text-field
          need
          label="Tipas"
          tooltip="Hipoteka. Turtas. Orlaivis. Tipas"
          :counter="80"
          :readonly="turtasReadonly"
          v-model="formData.tur_orlaivis_tipas"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'TurtasOrlaivis',
  props: {
    formData: Object,
    readonly: Boolean,
    irasomas: Boolean,
    sudarymas: Boolean,
  },
  inject: {
    $validator: '$validator',
  },
  computed: {
    turtasReadonly() {
      return this.readonly || !this.irasomas
    },
  },
}
</script>
